import { Component, OnInit } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { GurdServiceService } from 'src/app/Service/gurd-service.service';
import { NotificationService } from 'src/app/Service/notification.service';
import { OtherService } from 'src/app/Service/other.service';
import axios from 'src/app/Service/axios';
import * as moment from 'moment-jalaali';
import * as XLSX from 'xlsx';
declare let $: any;

@Component({
  selector: 'app-fuel-based-report',
  templateUrl: './fuel-based-report.component.html',
  styleUrls: ['./fuel-based-report.component.css']
})

export class FuelBasedReportComponent implements OnInit {
  lst_Result: any = [];
  lst_Search: any = [];
  fuelDetails: any = [];
  totalLiter: number = 0;
  totalCost: number = 0;

  mdl_Search: FormGroup = this.FormBuilder.group({
    iSystemUser: new FormControl(this.gurdService.decrypt(localStorage.getItem('ID')!)),
    strSession: new FormControl(this.gurdService.decrypt(localStorage.getItem('Session')!)),
    strSDate: new FormControl(moment().format('jYYYY/jMM/01')),
    strEDate: new FormControl(''),
    strUnitID: new FormControl(''),
  });

  constructor(
    private _tooltip: NotificationService,
    private FormBuilder: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private gurdService: GurdServiceService,
    private _otherService: OtherService,
    private meta: Meta,
    private title: Title
  ) { }

  ngOnInit(): void {
    this.meta.updateTag({ name: 'robots', content: 'noindex, nofollow' });
    this._otherService.setTitle('سوخت براساس گزارش ثبت‌شده');
  }

  ngOnDestroy() {
    this._otherService.setTitle('');
  }

  async getResult() {
    this._otherService.Showspinner();
    let res = JSON.parse((await axios.post(`FuelReport_ReportMobiles2`, this._otherService.stringNumberToNumber(this.mdl_Search.value))).data.toString());
    this._otherService.nonespinner();

    if (res.ISSessionExpired == true) {
      this._tooltip.showError('لطفا وارد سیستم شوید');
      this._otherService.removeLocalStorage();
      this.router.navigate(['login'], { queryParams: { error: 'x1x10' } });
      return;
    }

    if (res.iResult == 0) {
      return this._tooltip.showError(res.strError);
    }

    this.lst_Result = res;
    this.lst_Search = res;
    this.calculateTotals()

  }

  async openDetails(item) {
    this.mdl_Search.patchValue({
      strUnitID: item.strUnitID ?? '350612075313344'
    })

    this._otherService.Showspinner();
    let res = JSON.parse((await axios.post(`FuelReport_ReportMobile`, this._otherService.stringNumberToNumber(this.mdl_Search.value))).data.toString());
    this._otherService.nonespinner();

    if (res.ISSessionExpired == true) {
      this._tooltip.showError('لطفا وارد سیستم شوید');
      this._otherService.removeLocalStorage();
      this.router.navigate(['login'], { queryParams: { error: 'fuelReport' } });
      return;
    }

    if (res.iResult == 0) {
      return this._tooltip.showError(res.strError);
    }

    this.fuelDetails = res;

    $("#detailsModal").modal('show');

  }

  filterResult(val: any) {
    this.lst_Result = this.lst_Search.filter((el: any) => {
      return el?.strFullName?.includes(val.value) ||
        el.strVehicleNo?.toString().includes(val.value) ||
        el.strMobileType_strComment?.toString().includes(val.value)
    });
    if (val.value.trim() == '') {
      this.lst_Result = this.lst_Search;
    }
  }

  highlightText(text: string, searchTerm: string) {
    if (!searchTerm) {
      return text;
    }
    const regex = new RegExp(searchTerm, 'gi');
    return text?.replace(regex, (match: string) => {
      return `<mark>${match}</mark>`;
    });
  }

  calculateTotals() {
    this.totalLiter = 0;
    this.totalCost = 0;
    for (const item of this.lst_Result) {
      this.totalLiter += parseFloat(item.fLiter ?? 0);
      this.totalCost += parseFloat(item.iCost ?? 0);
    }
  }

  exportExcel(id: any): void {
    let element = document.getElementById(`${id}`);
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    XLSX.writeFile(wb, 'سوخت براساس گزارش ثبت‌شده.xlsx');
  }

}
